import { Controller } from "@hotwired/stimulus"

// Shows only the trigger input relevant to the selected trigger type:
//   - idle, time_on_page, video_dwell → trigger_seconds field
//   - pageviews                       → trigger_pageview_count field
//   - manual                          → neither (hides both)
export default class extends Controller {
  static targets = ["typeSelect", "secondsField", "pageviewsField"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasTypeSelectTarget) return
    const type = this.typeSelectTarget.value
    const showSeconds = ["idle", "time_on_page", "video_dwell"].includes(type)
    const showPageviews = type === "pageviews"

    if (this.hasSecondsFieldTarget) {
      this.secondsFieldTarget.classList.toggle("hidden", !showSeconds)
    }
    if (this.hasPageviewsFieldTarget) {
      this.pageviewsFieldTarget.classList.toggle("hidden", !showPageviews)
    }
  }
}
